import {
	CreateRichMenuTabGroup200ResponseSchema,
	CreateRichMenuTabGroup400ResponseSchema,
	CreateRichMenuTabGroup500ResponseSchema,
	// Rich Menu Tab Group API Schemas
	CreateRichMenuTabGroupRequestSchema,
	DeleteRichMenuTabGroup200ResponseSchema,
	DeleteRichMenuTabGroup400ResponseSchema,
	DeleteRichMenuTabGroup404ResponseSchema,
	DeleteRichMenuTabGroup500ResponseSchema,
	DeleteRichMenuTabGroupPathParamsSchema,
	DeleteRichMenuTabImage200ResponseSchema,
	DeleteRichMenuTabImage400ResponseSchema,
	DeleteRichMenuTabImage404ResponseSchema,
	DeleteRichMenuTabImage500ResponseSchema,
	DeleteRichMenuTabImagePathParamsSchema,
	GetRichMenu200ResponseSchema,
	GetRichMenu404ResponseSchema,
	GetRichMenu500ResponseSchema,
	// Rich Menu API Schemas
	GetRichMenuPathParamsSchema,
	GetRichMenuTabGroup200ResponseSchema,
	GetRichMenuTabGroup404ResponseSchema,
	GetRichMenuTabGroup500ResponseSchema,
	GetRichMenuTabGroupPathParamsSchema,
	GetRichMenuTabGroups200ResponseSchema,
	GetRichMenuTabGroups500ResponseSchema,
	GetRichMenuTabGroupsQueryParamsSchema,
	// Template API Schemas
	GetRichMenuTemplates200ResponseSchema,
	GetRichMenuTemplates404ResponseSchema,
	GetRichMenuTemplates500ResponseSchema,
	PublishRichMenuTabGroup200ResponseSchema,
	PublishRichMenuTabGroup400ResponseSchema,
	PublishRichMenuTabGroup404ResponseSchema,
	PublishRichMenuTabGroup500ResponseSchema,
	PublishRichMenuTabGroupPathParamsSchema,
	SetRichMenuImage200ResponseSchema,
	SetRichMenuImage400ResponseSchema,
	SetRichMenuImage404ResponseSchema,
	SetRichMenuImage500ResponseSchema,
	SetRichMenuImagePathParamsSchema,
	UnpublishRichMenuTabGroup200ResponseSchema,
	UnpublishRichMenuTabGroup400ResponseSchema,
	UnpublishRichMenuTabGroup404ResponseSchema,
	UnpublishRichMenuTabGroup500ResponseSchema,
	UnpublishRichMenuTabGroupPathParamsSchema,
	UpdateRichMenuTabGroup200ResponseSchema,
	UpdateRichMenuTabGroup404ResponseSchema,
	UpdateRichMenuTabGroup500ResponseSchema,
	UpdateRichMenuTabGroupPathParamsSchema,
	UpdateRichMenuTabGroupRequestSchema,
	UploadRichMenuImage200ResponseSchema,
	UploadRichMenuImage400ResponseSchema,
	UploadRichMenuImage500ResponseSchema,
} from "../schemas/richmenu.api.schemas";

// ============================================================================
// Rich Menu Template Contracts
// ============================================================================

/**
 * Get Rich Menu Templates contract
 * GET /richmenus/templates
 */
export const getRichMenuTemplatesContract = {
	path: "/richmenus/templates",
	contract: {
		method: "GET" as const,
		responses: {
			200: GetRichMenuTemplates200ResponseSchema,
			404: GetRichMenuTemplates404ResponseSchema,
			500: GetRichMenuTemplates500ResponseSchema,
		},
	},
} as const;

// ============================================================================
// Rich Menu Contracts
// ============================================================================

/**
 * Get Rich Menu contract
 * GET /richmenus/:id
 */
export const getRichMenuContract = {
	path: "/richmenus/:id",
	contract: {
		method: "GET" as const,
		params: GetRichMenuPathParamsSchema,
		responses: {
			200: GetRichMenu200ResponseSchema,
			404: GetRichMenu404ResponseSchema,
			500: GetRichMenu500ResponseSchema,
		},
	},
} as const;

/**
 * Get Current Rich Menu contract
 * GET /richmenu/current
 */
export const getCurrentRichMenuContract = {
	path: "/richmenu/current",
	contract: {
		method: "GET" as const,
		responses: {
			200: GetRichMenu200ResponseSchema,
			404: GetRichMenu404ResponseSchema,
			500: GetRichMenu500ResponseSchema,
		},
	},
} as const;

/**
 * Upload Rich Menu Image contract
 * POST /richmenus/upload-image
 */
export const uploadRichMenuImageContract = {
	path: "/richmenus/upload-image",
	contract: {
		method: "POST" as const,
		// Note: File upload handled through multipart/form-data
		responses: {
			200: UploadRichMenuImage200ResponseSchema,
			400: UploadRichMenuImage400ResponseSchema,
			500: UploadRichMenuImage500ResponseSchema,
		},
	},
} as const;

/**
 * Set Rich Menu Image contract
 * PUT /richmenus/:id/image
 */
export const setRichMenuImageContract = {
	path: "/richmenus/:id/image",
	contract: {
		method: "PUT" as const,
		params: SetRichMenuImagePathParamsSchema,
		// Note: File upload handled through multipart/form-data
		responses: {
			200: SetRichMenuImage200ResponseSchema,
			400: SetRichMenuImage400ResponseSchema,
			404: SetRichMenuImage404ResponseSchema,
			500: SetRichMenuImage500ResponseSchema,
		},
	},
} as const;

/**
 * Delete Rich Menu Tab Image contract
 * DELETE /richmenus/:id/image
 */
export const deleteRichMenuTabImageContract = {
	path: "/richmenus/:id/image",
	contract: {
		method: "DELETE" as const,
		params: DeleteRichMenuTabImagePathParamsSchema,
		responses: {
			200: DeleteRichMenuTabImage200ResponseSchema,
			400: DeleteRichMenuTabImage400ResponseSchema,
			404: DeleteRichMenuTabImage404ResponseSchema,
			500: DeleteRichMenuTabImage500ResponseSchema,
		},
	},
} as const;

// ============================================================================
// Rich Menu Tab Group Contracts
// ============================================================================

/**
 * Create Rich Menu Tab Group contract
 * POST /richmenu-tab-groups
 */
export const createRichMenuTabGroupContract = {
	path: "/richmenu-tab-groups",
	contract: {
		method: "POST" as const,
		body: CreateRichMenuTabGroupRequestSchema,
		responses: {
			200: CreateRichMenuTabGroup200ResponseSchema,
			400: CreateRichMenuTabGroup400ResponseSchema,
			500: CreateRichMenuTabGroup500ResponseSchema,
		},
	},
} as const;

/**
 * Get Rich Menu Tab Groups contract
 * GET /richmenu-tab-groups
 */
export const getRichMenuTabGroupsContract = {
	path: "/richmenu-tab-groups",
	contract: {
		method: "GET" as const,
		query: GetRichMenuTabGroupsQueryParamsSchema,
		responses: {
			200: GetRichMenuTabGroups200ResponseSchema,
			500: GetRichMenuTabGroups500ResponseSchema,
		},
	},
} as const;

/**
 * Get Rich Menu Tab Group contract
 * GET /richmenu-tab-groups/:tabGroupId
 */
export const getRichMenuTabGroupContract = {
	path: "/richmenu-tab-groups/:tabGroupId",
	contract: {
		method: "GET" as const,
		params: GetRichMenuTabGroupPathParamsSchema,
		responses: {
			200: GetRichMenuTabGroup200ResponseSchema,
			404: GetRichMenuTabGroup404ResponseSchema,
			500: GetRichMenuTabGroup500ResponseSchema,
		},
	},
} as const;

/**
 * Update Rich Menu Tab Group contract
 * PUT /richmenu-tab-groups/:tabGroupId
 */
export const updateRichmenuTabGroupContract = {
	path: "/richmenu-tab-groups/:tabGroupId",
	contract: {
		method: "PUT" as const,
		params: UpdateRichMenuTabGroupPathParamsSchema,
		body: UpdateRichMenuTabGroupRequestSchema,
		responses: {
			200: UpdateRichMenuTabGroup200ResponseSchema,
			404: UpdateRichMenuTabGroup404ResponseSchema,
			500: UpdateRichMenuTabGroup500ResponseSchema,
		},
	},
} as const;

/**
 * Delete Rich Menu Tab Group contract
 * DELETE /richmenu-tab-groups/:tabGroupId
 */
export const deleteRichMenuTabGroupContract = {
	path: "/richmenu-tab-groups/:tabGroupId",
	contract: {
		method: "DELETE" as const,
		params: DeleteRichMenuTabGroupPathParamsSchema,
		responses: {
			200: DeleteRichMenuTabGroup200ResponseSchema,
			400: DeleteRichMenuTabGroup400ResponseSchema,
			404: DeleteRichMenuTabGroup404ResponseSchema,
			500: DeleteRichMenuTabGroup500ResponseSchema,
		},
	},
} as const;

/**
 * Publish Rich Menu Tab Group contract
 * PUT /richmenu-tab-groups/:tabGroupId/publish
 */
export const publishRichmenuTabGroupContract = {
	path: "/richmenu-tab-groups/:tabGroupId/publish",
	contract: {
		method: "PUT" as const,
		params: PublishRichMenuTabGroupPathParamsSchema,
		responses: {
			200: PublishRichMenuTabGroup200ResponseSchema,
			400: PublishRichMenuTabGroup400ResponseSchema,
			404: PublishRichMenuTabGroup404ResponseSchema,
			500: PublishRichMenuTabGroup500ResponseSchema,
		},
	},
} as const;

/**
 * Unpublish Rich Menu Tab Group contract
 * PUT /richmenu-tab-groups/:tabGroupId/unpublish
 */
export const unpublishRichmenuTabGroupContract = {
	path: "/richmenu-tab-groups/:tabGroupId/unpublish",
	contract: {
		method: "PUT" as const,
		params: UnpublishRichMenuTabGroupPathParamsSchema,
		responses: {
			200: UnpublishRichMenuTabGroup200ResponseSchema,
			400: UnpublishRichMenuTabGroup400ResponseSchema,
			404: UnpublishRichMenuTabGroup404ResponseSchema,
			500: UnpublishRichMenuTabGroup500ResponseSchema,
		},
	},
} as const;

// ============================================================================
// Convenience Exports
// ============================================================================

/**
 * Rich menu paths as constants
 */
export const richmenuPaths = {
	templates: "/richmenus/templates",
	getRichMenu: "/richmenus/:id",
	uploadImage: "/richmenus/upload-image",
	setImage: "/richmenus/:id/image",
	tabGroups: "/richmenu-tab-groups",
	tabGroup: "/richmenu-tab-groups/:tabGroupId",
	publishTabGroup: "/richmenu-tab-groups/:tabGroupId/publish",
	unpublishTabGroup: "/richmenu-tab-groups/:tabGroupId/unpublish",
} as const;

/**
 * Combined contracts for convenience
 */
export const richmenuContracts = {
	getRichMenuTemplates: getRichMenuTemplatesContract,
	getRichMenu: getRichMenuContract,
	getCurrentRichMenu: getCurrentRichMenuContract,
	uploadRichMenuImage: uploadRichMenuImageContract,
	setRichMenuImage: setRichMenuImageContract,
	createRichMenuTabGroup: createRichMenuTabGroupContract,
	getRichMenuTabGroups: getRichMenuTabGroupsContract,
	getRichMenuTabGroup: getRichMenuTabGroupContract,
	publishRichmenuTabGroup: publishRichmenuTabGroupContract,
	unpublishRichmenuTabGroup: unpublishRichmenuTabGroupContract,
	updateRichmenuTabGroup: updateRichmenuTabGroupContract,
	deleteRichMenuTabGroup: deleteRichMenuTabGroupContract,
} as const;
